// import { canUseDOM } from 'exenv';

export function jwRelatedVideoLoading(resp = {}, store = {}) {
  return {
    type: 'JW_RELATED_VIDEO_LOADING',
    jwRelatedVideo: resp,
    store
  };
}

export function jwRelatedVideoLoaded(resp = {}, store = {}) {
  return {
    type: 'JW_RELATED_VIDEO_LOADED',
    jwRelatedVideo: resp,
    store
  };
}

export function jwRelatedVideoLoadError(error, store = {}) {
  return {
    type: 'JW_RELATED_VIDEO_ERROR',
    jwRelatedVideo: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store
  };
}
